import * as React from 'react'
import { LessonTypeId, getLessonTypeSpec } from '../LessonListContent'

type ItemProps = {
  lessonTypeId: LessonTypeId
  actionButton: JSX.Element
}

export const LessonTypeSummaryCard = ({
  lessonTypeId,
  actionButton,
}: ItemProps) => {
  if (!lessonTypeId) {
    return null
  }
  return (
    <div
      id={`type-summary-card-${lessonTypeId}`}
      className="bg-white border border-border-gray-0 box-border relative flex-grow-0 flex-shrink-0 desktop:w-[327px] sp:flex-grow"
    >
      <div className="font-yu-gothic text-xs leading-5 tracking-[1.6px] sp:text-[3.2vw] sp:leading-[5.33vw] sp:tracking-[0.427vw] font-bold flex items-center justify-between h-[68px] desktop:px-4 desktop:py-2 sp:px-[4.27vw] sp:py-[2.13vw] sp:pl-[3.73vw]">
        <div>{getLessonTypeSpec(lessonTypeId)?.label}</div>
        {actionButton}
      </div>
    </div>
  )
}
